export { default as General } from 'depreciations/components/form/sections/DepreciationFormGeneral';
export { default as Years } from 'depreciations/components/form/sections/DepreciationFormYears';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/form/sections/index.js